import React from 'react';
import { Container } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { FaCode, FaDatabase, FaBrain, FaServer, FaTools, FaRocket, FaLaptopCode, FaStar, FaStarHalfAlt, FaRegStar } from 'react-icons/fa';
import '../Styles/Skills.css';

function Skills() {
    const skills = [
        {
            name: "Programming Languages",
            icon: <FaCode />,
            subSkills: [
                { name: "Python", rating: 5 },
                { name: "Java", rating: 4 },
                { name: "JavaScript", rating: 4 },
                { name: "TypeScript", rating: 4 },
                { name: "React.js", rating: 4 }
            ]
        },
        {
            name: "Frameworks / Backend & APIs",
            icon: <FaServer />,
            subSkills: [
                { name: "FastAPI", rating: 4.5 },
                { name: "Flask", rating: 4.5 },
                { name: "Spring Boot", rating: 4 },
                { name: "Node.js", rating: 3.5 },
                { name: "RESTful APIs", rating: 4.5 }
            ]
        },
        {
            name: "AI / ML",
            icon: <FaBrain />,
            subSkills: [
                { name: "LangGraph", rating: 4.5 },
                { name: "RAG", rating: 4.5 },
                { name: "NLP", rating: 4 },
                { name: "LLMs", rating: 4 }
            ]
        },
        {
            name: "Cloud & DevOps",
            icon: <FaRocket />,
            subSkills: [
                { name: "Google Cloud", rating: 4.5 },
                { name: "AWS", rating: 4 },
                { name: "Azure", rating: 4 },
                { name: "Docker", rating: 4 },
                { name: "Kubernetes", rating: 3 },
                { name: "Terraform", rating: 3 },
                { name: "CI/CD", rating: 4 },
                { name: "Git", rating: 4.5 }
            ]
        },
        {
            name: "Databases & Analytics",
            icon: <FaDatabase />,
            subSkills: [
                { name: "PostgreSQL", rating: 4.5 },
                { name: "MySQL", rating: 4.5 },
                { name: "SQL Server", rating: 4.5 },
                { name: "BigQuery", rating: 4 },
                { name: "MongoDB", rating: 4 },
                { name: "DuckDB", rating: 4 },
                { name: "Oracle", rating: 3.5 },
                { name: "SQLite", rating: 3.5 }
            ]
        },
        {
            name: "Observability & Platform",
            icon: <FaTools />,
            subSkills: [
                { name: "OpenTelemetry", rating: 4 },
                { name: "Grafana", rating: 4 },
                { name: "Prometheus", rating: 3.5 }
            ]
        },
        {
            name: "Architecture & Practices",
            icon: <FaLaptopCode />,
            subSkills: [
                { name: "Distributed Systems", rating: 4 },
                { name: "Microservices", rating: 4 }
            ]
        }
    ];

    const StarRating = ({ rating }) => {
        const stars = [];
        for (let i = 1; i <= 5; i++) {
            if (i <= rating) {
                stars.push(<FaStar key={i} />);
            } else if (i - 0.5 <= rating) {
                stars.push(<FaStarHalfAlt key={i} />);
            } else {
                stars.push(<FaRegStar key={i} />);
            }
        }
        return <div className="star-rating">{stars}</div>;
    };

    return (
        <section id="skills" className="skills-section">
            <Container>
                <motion.h2 
                    className="section-title"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                    viewport={{ once: true }}
                >
                    Key Skills
                </motion.h2>
                <div className="skills-grid">
                    {skills.map((skill, index) => (
                        <motion.div
                            key={index}
                            className="skill-card"
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: index * 0.1 }}
                            viewport={{ once: true }}
                        >
                            <div className="skill-icon">{skill.icon}</div>
                            <h3 className="skill-name">{skill.name}</h3>
                            <div className="sub-skills">
                                {skill.subSkills.map((subSkill, i) => (
                                    <div key={i} className="sub-skill">
                                        <span className="sub-skill-name">{subSkill.name}</span>
                                        <StarRating rating={subSkill.rating} />
                                    </div>
                                ))}
                            </div>
                        </motion.div>
                    ))}
                </div>
            </Container>
        </section>
    );
}

export default Skills;
